/**
 * Risk Assessment Record Mapper
 * Converts backend RiskAssessmentRecord[] to frontend SavedAssessment[].
 * Centralises the mapping so every callsite stays consistent.
 */

import type { RiskAssessmentRecord } from '../services/wsApi';
import type { SavedAssessment } from '../types/risk-assessment.types';
import { mapBackendRiskLevel } from './assessmentHelpers';

/**
 * Map an array of backend risk assessment records to SavedAssessment[].
 */
export function mapRiskRecordsToAssessments(
	records: RiskAssessmentRecord[],
): SavedAssessment[] {
	return records.map((r) => ({
		id: r.assessmentId,
		clientName: r.clientName ?? '',
		clientRef: r.clientRef ?? '',
		entityAbn: r.entityAbn ?? '',
		riskRating: mapBackendRiskLevel(r.riskLevel),
		savedAt: r.updatedAt ?? r.createdAt ?? new Date().toISOString(),
		profession: r.profession ?? '',
		progress: r.progress ?? 100,
		c2EntityType: r.c2EntityType ?? '',
		contactPerson: r.contactPerson ?? '',
		contactPhone: r.contactPhone ?? '',
	}));
}
